export default "__VITE_ASSET__DozVHTd6__"